import React from 'react';
import { SaveButtonStyle } from './SaveButton.styles';
import { Save } from 'lucide-react';
import { useIntl } from 'react-intl';

interface SaveButtonProps {
  onClick: () => void;
}

export const SaveButton: React.FC<SaveButtonProps> = ({ onClick }) => (

  <SaveButtonStyle
    onClick={onClick}
    aria-label={useIntl().formatMessage({ id: "save" })}
    title={useIntl().formatMessage({ id: "save" })}>
    <Save size={18} strokeWidth={2.5} />
  </SaveButtonStyle>
);